import './support-material-link.css';

import { DsIcon } from '@descomplica/design-system-react';
import { useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';

import {
  Classroom,
  ClassroomViewModel,
  Lesson,
  SupportMaterial,
} from '@/presentation/screens/classroom/classroom.vm';
import { LinkContainer } from '@/presentation/shared-components/anchor';

type SupportMaterialTracking = {
  classroom: Classroom;
  lesson: Lesson;
};

type Params = {
  supportMaterial: SupportMaterial;
};

const SupportMaterialLink: React.FC<Params & SupportMaterialTracking> = ({
  lesson,
  supportMaterial,
}) => {
  const vm = useViewModel(ClassroomViewModel);

  return (
    <LinkContainer
      onClick={() => vm.handleSupportMaterialOpened(lesson, supportMaterial)}
      className="support-material-button"
      href={supportMaterial.url}
      aria-label="Abrir materiais de apoio"
      target="_blank"
      rel="noopener noreferrer"
    >
      <DsIcon image="material" />
      <p>Material de Apoio</p>
    </LinkContainer>
  );
};

export default SupportMaterialLink;
